import { useCallback, useEffect, useState } from 'react';

const KEY = 'alpha.features.v1';
// структура: { sharedDrives:{requested:boolean, enabled:boolean}, sharedWithMe:{requested:boolean, enabled:boolean} }

const DEFAULTS = {
    sharedDrives: { requested: false, enabled: false },
    sharedWithMe: { requested: false, enabled: false },
};

export default function useFeatures() {
    const [features, setFeatures] = useState(DEFAULTS);

    useEffect(() => {
        try {
            const raw = localStorage.getItem(KEY);
            if (raw) {
                const parsed = JSON.parse(raw);
                setFeatures({ ...DEFAULTS, ...parsed });
            }
        } catch { /* */ }
    }, []);

    const save = useCallback((next) => {
        setFeatures(next);
        try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* */ }
    }, []);

    const setRequested = useCallback((key, val) => {
        save({ ...features, [key]: { ...(features[key] || {}), requested: !!val } });
    }, [features, save]);

    const setEnabled = useCallback((key, val) => {
        save({ ...features, [key]: { ...(features[key] || {}), enabled: !!val } });
    }, [features, save]);

    return { features, setRequested, setEnabled, save };
}
